// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: Microsoft four-square mark, shared by SSO and calendar surfaces.

import type {CSSProperties} from 'react';

interface MicrosoftLogoProps {
	size?: number;
	style?: CSSProperties;
}

export function MicrosoftLogo({size = 16, style}: MicrosoftLogoProps) {
	return (
		<svg width={size} height={size} viewBox="0 0 16 16" aria-hidden="true" style={{flexShrink: 0, ...style}}>
			<rect x="0" y="0" width="7.5" height="7.5" fill="#F25022" />
			<rect x="8.5" y="0" width="7.5" height="7.5" fill="#7FBA00" />
			<rect x="0" y="8.5" width="7.5" height="7.5" fill="#00A4EF" />
			<rect x="8.5" y="8.5" width="7.5" height="7.5" fill="#FFB900" />
		</svg>
	);
}
